const CAROUSEL_ITEMS = [
  {
    id: 1,
    title: '91年国产影片回顾',
    desc: '1991年是中国电影的重要年份，涌现了大量优秀国产影片。本专题带您重温那个黄金年代的光影记忆。',
    tag: '年代特辑',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Chinese%20cinema%20nostalgia%20scene%20with%20vintage%20film%20reels%20and%20warm%20golden%20lighting%2C%20old%20movie%20theater%20atmosphere%2C%20rich%20sepia%20and%20amber%20tones%2C%20artistic%20film%20posters%20on%20wall%2C%20elegant%20composition&width=900&height=500&seq=carousel-91video-01&orientation=landscape',
  },
  {
    id: 2,
    title: '国产热播剧每日更新',
    desc: '紧跟国产电视剧最新动态，热门剧集每日准时更新。从此告别剧荒，精彩剧情尽在掌握。',
    tag: '每日追剧',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cozy%20viewing%20room%20with%20large%20screen%20and%20warm%20ambient%20glow%2C%20comfortable%20home%20cinema%20setting%2C%20soft%20evening%20light%2C%20rich%20crimson%20and%20golden%20highlights%2C%20inviting%20entertainment%20atmosphere&width=900&height=500&seq=carousel-91video-02&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺节目爆笑合集',
    desc: '精选国产综艺中最搞笑的片段与名场面，欢乐解压首选，让笑声成为每天的背景音。',
    tag: '欢乐时刻',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20television%20studio%20with%20bright%20warm%20stage%20lighting%2C%20entertainment%20show%20production%20atmosphere%2C%20vibrant%20amber%20and%20golden%20spotlights%2C%20lively%20broadcast%20setting%2C%20festive%20mood&width=900&height=500&seq=carousel-91video-03&orientation=landscape',
  },
  {
    id: 4,
    title: '91视频网站观影指南',
    desc: '新用户入门指南，快速了解平台功能特色。从搜索到收藏，一站式掌握91国产视频的正确打开方式。',
    tag: '新手指南',
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20workspace%20with%20laptop%20displaying%20cinematic%20content%2C%20soft%20natural%20light%20from%20window%2C%20cozy%20modern%20setting%2C%20rich%20golden%20and%20crimson%20accents%2C%20elegant%20creative%20atmosphere&width=900&height=500&seq=carousel-91video-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">焦点推荐</h2>
          <p className="text-sm md:text-base text-foreground-500">本周不可错过的91国产视频精选内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-2xl overflow-hidden cursor-pointer group h-full flex flex-col">
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  title={`91视频网站 - ${item.title}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-4 flex flex-col flex-1">
                <span className="inline-block px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-2 self-start whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}